import {
  SkipLimitPageSpec,
  SortDirection,
} from '@warebee/shared/data-access-api-dto';
import _ from 'lodash';

import {
  ActualityAggregatedHqQueryBuilderParams,
  ActualityAggregatedHqSortBy,
  getActualityAggregatedHqQueryBuilder,
} from './cteQueryBuilders/actualityAggregatedHqQueryBuilder';

export type ActualityAggregatedHqQueryBuilderPagedParams =
  ActualityAggregatedHqQueryBuilderParams & {
    sortBy?: ActualityAggregatedHqSortBy[];
    page?: SkipLimitPageSpec;
  };

function getActualityAggregatedHqDataRowsBasePart(
  params: ActualityAggregatedHqQueryBuilderParams,
) {
  return getActualityAggregatedHqQueryBuilder(params)
    .selectFrom('ahq')
    .selectAll();
  // if (params.filterBy) {
  //   query = _.reduce(
  //     params.filterBy,
  //     (q, value, key) => {
  //       if (
  //         value?.type === StringSearchFilterType.CONTAINS &&
  //         value?.value === 'undefined'
  //       ) {
  //         return q.where(key as any, 'is', null);
  //       }

  //       if (
  //         value?.type === StringSearchFilterType.CONTAINS &&
  //         !_.isEmpty(value?.value)
  //       ) {
  //         return q.where(key as any, 'like', `%${value.value}%`);
  //       }
  //       return q;
  //     },
  //     query,
  //   );
  // }
}

export function getActualityAggregatedHqDataTotalQuery(
  params: ActualityAggregatedHqQueryBuilderParams,
) {
  let builder = getActualityAggregatedHqDataRowsBasePart(params)
    .clearSelect()
    .select(({ fn }) => [fn.countAll<number>().as('totalCount')]);
  return builder;
}

export function getActualityAggregatedHqDataRowsQuery(
  params: ActualityAggregatedHqQueryBuilderPagedParams,
) {
  let query = getActualityAggregatedHqDataRowsBasePart(params)
    .$if(!_.isNil(params.page), db => db.offset(params.page.skip ?? 0))
    .$if(!_.isNil(params.page), db => db.limit(params.page.limit ?? 100));

  _.forEach(params.sortBy, sb => {
    query = query.orderBy(
      sb.field,
      sb.direction === SortDirection.ASC ? 'asc' : 'desc',
    );
  });
  return query;
}
